import { Box } from '@mui/material';
import { ValidationErrors } from 'final-form';

interface RenderErrorMessageProps {
  errors: ValidationErrors;
  field: string | null | undefined;
}

export const RenderErrorMessage: React.FC<RenderErrorMessageProps> = props => {
  const { errors, field } = props;

  return (
    <Box
      mb={3}
      sx={theme => ({
        textTransform: 'lowercase',
        color: theme.palette.error.main,
      })}
    >
      {errors?.[field as string]}
    </Box>
  );
};
